import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BaseService} from '../../../shared/services/base.service';
import {GameTableParticipationRequest} from '../../../shared/model/game-table-participation-request';
import {ApiResponse} from '../../../shared/model/api-response';
import {GameTableParticipation} from '../../../shared/model/game-table-participation';

@Injectable({
  providedIn: 'root'
})
export class GameTableParticipationService extends BaseService {

  private httpClient: HttpClient = inject(HttpClient);

  public participateToTable(request: GameTableParticipationRequest): Observable<ApiResponse<GameTableParticipation>> {
    return this.httpClient.post<ApiResponse<GameTableParticipation>>(`${this.baseUrl}/game-table-participation`, request);
  }

  public acceptParticipation(id: number): Observable<ApiResponse<GameTableParticipation>> {
    return this.httpClient.put<ApiResponse<GameTableParticipation>>(`${this.baseUrl}/game-table-participation/${id}/accept`, {});
  }

  public removeParticipation(id: number): Observable<ApiResponse<string>> {
    return this.httpClient.delete<ApiResponse<string>>(`${this.baseUrl}/game-table-participation/${id}`);
  }
}









